import {Component} from '@angular/core';
import {ScreenService} from '@app/core';
import {GlobalSearchService} from '../../../../core/services/global-search.service';
import {GeneralFilter} from '@app/shared';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-search',
  standalone: false,

  templateUrl: './search.component.html',
  styleUrl: './search.component.less'
})
export class SearchComponent {

  filters: GeneralFilter[] = [
    {name: 'Todos', icon: 'all_inclusive', active: true, code: 'All'},
    {name: 'Órdenes de servicio', icon: '', active: false},
    {name: 'Servicios', icon: '', active: false},
    {name: 'Proyectos', icon: '', active: false},
  ];

  loading: boolean = false;

  constructor(
    public screenService: ScreenService,
    private globalSearchService: GlobalSearchService
  ) {
    this.globalSearchService.loading$
      .pipe(takeUntilDestroyed())
      .subscribe(value => {
        this.loading = value;
      });
  }

  goBack() {
    window.history.back();
  }

  onFilterSelect(filter: GeneralFilter) {
    this.filters.forEach(f => f.name === filter.name ? f.active = true : f.active = false);
  }

}
